import PromotionCard from "components/PromotionCard";

const PromotionsPage = () => {
  return (
    <section className="Promotions pb-120">
      {/* <link rel="stylesheet" href="/assets/css/style.min.css"> */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 gx-0 gx-lg-4">
            <div className="Promotions__main">
              <div className="row w-100 gy-6">
                <span className="d-block mb-3 text-warning">
                  This page is under development. Promotions hold no real value.
                </span>
                <div className="col-12">
                  <h3>Promotions for you</h3>
                </div>
                <PromotionCard
                  category="Cashback Bonus"
                  title="Earn 25$ after placing qualifying order!"
                  description="Earn an 25$ Amazon&trade; gift card upon completing an order costing more than 1,000$. The offer is only valid if the user does not cash you the order, fully or partially. Only redeemable once per account."
                  buttonText="Get Bonus"
                />
                <PromotionCard
                  category="Refer & Earn"
                  title="Win a watch in our Exclusive Giveaway!"
                  description="Invite your friends to join our platform and earn a ticket for the giveaway for every successful referral. The more friends you refer, the more chance to win the watch you have!"
                  buttonText="Get Bonus"
                />
                <PromotionCard
                  category="Institutional Traders"
                  title="Big Advantages For Big Traders"
                  description="Get +2% better odds upon high volume! This offer is only valid for institutional traders with a minimum monthly trading volume of 100,000$. Contact us to learn more about this exclusive offer."
                  buttonText="Contact Us"
                />
                <PromotionCard
                  category="Summer Prediction Competition 2025"
                  title="Up to 10,000$ in prizes for the best predictions"
                  description="Join our Summer Prediction Competition 2025 and stand a chance to win up to 10,000$ in prizes! Submit your predictions for the biggest events of the summer and compete with other traders."
                  buttonText="Participate Now"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- ==== js dependencies start ==== --> */}
      {/* <script src="/assets/js/plugins/plugins.js"></script>
            <script src="/assets/js/plugins/plugin-custom.js"></script>
            <script src="/assets/js/main.js"></script> */}
    </section>
  );
};

export default PromotionsPage;
